<!--
 * @Author: 赵健
 * @Date: 2021-01-14 10:51:47
 * @LastEditTime: 2021-01-28 15:54:22
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\dashboard\index.vue
-->
<template>
  <div
    v-loading="loading"
    class="bg"
  >
    <div class="con">
      <div class="big-title">欢迎登录商家系统</div>
      <div class="small-title">
        WELCOME TO LOGIN MERCHANT SYSTEM
      </div>
      <div class="btn">
        <el-button type="primary" round @click="$router.push({path:'/merchant/orderManage'})">待确认订单{{ confirmedNum }}条</el-button>
        <el-button type="warning" round @click="$router.push({path:'/merchant/orderManage',query:{type:1}})">待核销订单{{ toUsedNum }}条</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { merchantRecordNum } from '@/api/dashBoard'
export default {
  name: 'Dashboard',
  data() {
    return {
      loading: false,
      confirmedNum: 0, // 待确认
      toUsedNum: 0 // 待核销
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        this.loading = true
        const res = await merchantRecordNum()
        this.confirmedNum = res.data.orderNumber.confirmedNum
        this.toUsedNum = res.data.orderNumber.toUsedNum
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  position: relative;
  height: calc(100vh - 100px);
  background-color: #fff;
  background-image: url("../../../src/assets/images/dashboard-bg.png");
  background-repeat: no-repeat;
  background-size: 600px 450px;
  background-position: 10% 50%;

  .con {
    position: absolute;
    right: 10%;
    top: 150px;

    .big-title {
      font-family: PingFangSC-Medium;
      font-size: 40px;
      color: #2b6fef;
      letter-spacing: 10.67px;
    }

    .small-title {
      margin-top: 20px;
      font-family: PingFangSC-Regular;
      font-size: 19px;
      color: #2b6fef;
      letter-spacing: 0;
      text-align: center;
    }

    .btn{
      margin-top: 50px;
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
